import React, { useEffect, useRef } from "react";
import "./ReviewsScroll.css";

// videos
import testimonial1 from "./media/reel141.mp4";
import testimonial2 from "./media/testi223.mp4";
import testimonial3 from "./media/testi3.mov";

// posters (add these images in ./media/)
import poster1 from "./media/ps51.jpg";
import poster2 from "./media/prime81.jpg";
import poster3 from "./media/ps21.jpg";

const testimonials = [
  { file: testimonial1, poster: poster1 },
  { file: testimonial2, poster: poster2 },
  { file: testimonial3, poster: poster3 },
];

export default function ReviewsSection() {
  const sliderRef = useRef(null);

  // keep the auto-scroll behavior
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const CARD_STEP = 380;
    const INTERVAL_MS = 10000;

    const id = setInterval(() => {
      const atEnd =
        slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 5;

      if (atEnd) {
        slider.scrollTo({ left: 0, behavior: "auto" });
      } else {
        slider.scrollBy({ left: CARD_STEP, behavior: "smooth" });
      }
    }, INTERVAL_MS);

    return () => clearInterval(id);
  }, []);

  return (
    <section className="review-section">
      <div className="review-header-row">
        <h2 className="review-main-heading">Why People Love Us</h2>
        <span className="review-badge">Hear stories from our patients</span>
      </div>

      <div className="review-slider-outer">
        <div className="review-slider" ref={sliderRef}>
          {testimonials.map((t, i) => (
            <div className="testimonial-card" key={i}>
              <video
                className="testimonial-video"
                src={t.file}
                poster={t.poster}
                preload="none"
                muted
                controls
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
